export default {
    path: '/warehouse-permissions',
    name: 'WarehousePermissions',
    component: () => import('@/layout/index.vue'),
    redirect: {
        name: 'IncomingMaterialReceipt',
    },
    meta: {
        title: '仓库',
        icon: 'iconfont icon-jiancaixuangou',
        role: 'BACK_MENU3'
    },
    children: [{
            path: '/incoming-material-receipt',
            name: 'IncomingMaterialReceipt',
            meta: {
                title: '来料收货',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M1'
            },
            component: () => import('@/views/RawMaterialWarehouse/IncomingMaterialReceipt.vue'),
        },
        {
            path: '/whInventory',
            name: 'WhInventory',
            meta: {
                title: "库存",
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M2'
            },
            component: () => import('@/views/Production/WhInventory.vue')
        },
        {
            path: '/warehouseCall',
            name: 'WarehouseCall',
            meta: {
                title: "仓库叫料",
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M25'
            },
            component: () => import('@/views/RawMaterialWarehouse/WarehouseCall.vue')
        },
        {
            path: '/materialDistributionDetails',
            name: 'MaterialDistributionDetails',
            meta: {
                title: '配送详情',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M3'
            },
            component: () => import('@/views/Production/MaterialDistributionDetails.vue'),
        },
        {
            path: '/materialDistributionnew',
            name: 'MaterialDistributionnew',
            meta: {
                title: '物料配送',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M4'
            },
            component: () => import('@/views/RawMaterialWarehouse/MaterialDistribution-new.vue'),
        },
        {
            path: '/missionQuery',
            name: 'MissionQuery',
            meta: {
                title: '任务查询',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M5'
            },
            component: () => import('@/views/RawMaterialWarehouse/MissionQuery.vue'),
        },
        {
            path: '/materialReturnConfirm',
            name: 'materialReturnConfirm',
            meta: {
                title: '退料确认',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M6'
            },
            component: () => import('@/views/RawMaterialWarehouse/MaterialReturnConfirm.vue'),
        },
        {
            path: '/locationAdjustment',
            name: 'LocationAdjustment',
            meta: {
                title: '物料移库',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M7'
            },
            component: () => import('@/views/RawMaterialWarehouse/LocationAdjustment.vue'),
        },
        {
            path: '/transferWriteXA',
            name: 'TransferWriteXA',
            component: () => import('@/views/RawMaterialWarehouse/TransferWriteXA.vue'),
            meta: {
                title: '交易记录查询',
                role: 'BACK_MENU3_M8'
            }
        },
        {
            path: '/finishedProductLoad',
            name: 'FinishedProductLoad',
            meta: {
                title: '成品装车',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M9'
            },
            component: () => import('@/views/RawMaterialWarehouse/FinishedProductLoad.vue'),
        },
        {
            path: '/unpacking',
            name: 'Unpacking',
            meta: {
                title: '拆合包',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M10'
            },
            component: () => import('@/views/RawMaterialWarehouse/Unpacking.vue'),
        },
        {
            path: '/PickingConfirmationMat',
            name: 'PickingConfirmationMat',
            meta: {
                title: '拣货列表',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M11'
            },
            component: () => import('@/views/RawMaterialWarehouse/PickingConfirmationMat.vue'),
        },
        {
            path: '/photograph',
            name: 'Photograph',
            component: () => import('@/views/RawMaterialWarehouse/photograph.vue'),
            meta: {
                title: '图片管理',
                role: 'BACK_MENU3_M12'
            }
        },
        {
            path: '/pointConfiguration',
            name: 'PointConfiguration',
            meta: {
                title: '点位配置',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M13'
            },
            component: () => import('@/views/RawMaterialWarehouse/PointConfiguration.vue'),
        },
        {
            path: '/putawayConfirm',
            name: 'PutawayConfirm',
            meta: {
                title: '上架入库',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M14'
            },
            component: () => import('@/views/RawMaterialWarehouse/PutawayConfirm.vue'),
        },
        {
            path: '/purchaseReturn',
            name: 'PurchaseReturn',
            meta: {
                title: '采购退货',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M15'
            },
            component: () => import('@/views/RawMaterialWarehouse/PurchaseReturn.vue'),
        },

        {
            path: '/otherRecordOut',
            name: 'otherRecordOut',
            meta: {
                title: '交易调整',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M16'
            },
            component: () => import('@/views/RawMaterialWarehouse/OtherRecordOut.vue'),
        },
        {
            path: '/stockTakeProject',
            name: 'StockTakeProject',
            meta: {
                title: '盘点计划',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M17'
            },
            component: () => import('@/views/RawMaterialWarehouse/StockTakeProject.vue'),
        },
        {
            path: '/stockTakeExecute',
            name: 'StockTakeExecute',
            meta: {
                title: '盘点执行',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M18'
            },
            component: () => import('@/views/RawMaterialWarehouse/StockTakeExecute.vue'),
        },


        {
            path: '/statusTransition',
            name: 'StatusTransition',
            meta: {
                title: '物料状态转换',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M19'
            },
            component: () => import('@/views/RawMaterialWarehouse/StatusTransition.vue'),
        },
        {
            path: '/statusTransitionRecord',
            name: 'StatusTransitionRecord',
            meta: {
                title: '物料状态转换记录',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M20'
            },
            component: () => import('@/views/RawMaterialWarehouse/StatusTransitionRecord.vue'),
        },
        {
            path: '/constituteDisc',
            name: 'ConstituteDisc',
            meta: {
                title: '组盘',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M21'
            },
            component: () => import('@/views/RawMaterialWarehouse/ConstituteDisc.vue'),
        },
        {
            path: '/whXaRecord',
            name: 'WhInventoryXaRecord',
            component: () => import('@/views/RawMaterialWarehouse/WhInventoryXaRecord.vue'),
            meta: {
                title: '库存对比',
                role: 'BACK_MENU3_M22'
            }
        },
        {
            path: '/zspPallet',
            name: 'ZspPallet',
            meta: {
                title: '托盘明细',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M24'
            },
            component: () => import('@/views/RawMaterialWarehouse/zspPallet.vue'),
        },
        {
            path: '/zspPalletManage',
            name: 'ZspPalletManage',
            meta: {
                title: '托盘管理',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M24'
            },
            component: () => import('@/views/RawMaterialWarehouse/zspPalletManage.vue'),
        },
        {
            path: '/outerWarehouseLoading',
            name: 'OuterWarehouseLoading',
            meta: {
                title: '外仓装车',
                icon: 'el-icon-menu',
                role: 'BACK_MENU3_M26'
            },
            component: () => import('@/views/OuterWarehouseLoading/index.vue'),
        },
    ],
}